import React from 'react';
import styled from 'styled-components';
import Dialog from '@mui/material/Dialog/Dialog';
import Slide from '@mui/material/Slide/Slide';
import TrueImpactText from '../base/TrueImpactText';
import SearchField from '../../components/Feedback/FiltersDropdown/SearchField';
import { TransitionProps } from '@mui/material/transitions/transition';
import { thinScrollbarStyles } from '../settings/variables/Scrollbar';
import { COLORS } from '../settings/variables/Colors';

const Transition = React.forwardRef(
  (
    props: TransitionProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
  ) => <Slide direction="up" ref={ref} {...props} />,
);

interface TrueImpactFilterModalProps {
  label?: string;
  description?: string;
  open: boolean;
  heading: string;
  searchText: string | undefined;
  children?: React.ReactNode | React.ReactNode[];
  onClose: () => unknown;
  onSearchTextChange: (text: string) => unknown;
}

const StyledDiv = styled.div`
  min-height: 480px;
  overflow-y: auto;
  .title {
    margin: 24px 48px;
  }
  .search-wrapper {
    background-color: ${COLORS.greyBase};
    padding: 16px 48px;
  }
  .filters-wrapper {
    ${thinScrollbarStyles}
    height: 478px;
    overflow-y: auto;
    padding: 37px 48px;
    @media only screen and (max-width: 478px) {
      height: 100%;
    }
  }
`;

const TrueImpactFilterModal: React.FC<TrueImpactFilterModalProps> = ({
  label,
  description,
  open,
  searchText,
  onSearchTextChange: handleSearchTextChange,
  heading,
  children,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      maxWidth="sm"
      fullWidth
      onClose={onClose}
      aria-labelledby={label}
      aria-describedby={description}
    >
      <StyledDiv>
        <TrueImpactText variant="heading" color="greyDark" className="title">
          {heading}
        </TrueImpactText>
        <div className="search-wrapper">
          <SearchField
            name="search-filters"
            size="small"
            value={searchText}
            onChange={handleSearchTextChange}
            placeholder="Search Filters"
          />
        </div>
        <div className="filters-wrapper">{children}</div>
      </StyledDiv>
    </Dialog>
  );
};

export default TrueImpactFilterModal;
